export default __webpack_public_path__ + "static/media/img_05.a83b7895.jpg";